export const catalog_matrix = [
    {form_key:'taxpayer_type_id', catalog_key:'tax_payer_types'},
];
